import React from 'react';
import { Link } from 'react-router-dom';

const Impresszum = () => {
  return (
    <div className="min-h-screen px-4 sm:px-6 lg:px-8 py-16">
      <div className="max-w-3xl mx-auto bg-white/[0.03] border border-white/10 rounded-2xl p-8 sm:p-12 shadow-[0_0_30px_rgba(0,0,0,0.5)]">
        <h1 className="brand glow text-center text-yellow-200 text-5xl mb-10">Impresszum</h1>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">Szolgáltató adatai</h2>
          <p className="text-gray-200 mb-1"><strong className="text-white">Vállalkozó neve:</strong> Tóth Eszter E.V.</p>
          <p className="text-gray-200 mb-1"><strong className="text-white">Székhely:</strong> 1033 Budapest, Harrer Pál utca 16/52.</p>
          <p className="text-gray-200 mb-1"><strong className="text-white">Nyilvántartási szám:</strong> 60753388</p>
          <p className="text-gray-200 mb-1"><strong className="text-white">Adószám:</strong> 90231991-1-41</p>
          <p className="text-gray-200 mb-1">
            <strong className="text-white">E-mail cím:</strong>{' '}
            <a href="mailto:celestinethewitch@gmail.com" className="text-yellow-200 hover:underline">celestinethewitch@gmail.com</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">Hosting szolgáltató</h2>
          <p className="text-gray-200 mb-1"><strong className="text-white">Név:</strong> WordPress (Automattic, Inc.)</p>
          <p className="text-gray-200 mb-1"><strong className="text-white">Cím:</strong> 60 29th Street #343, San Francisco, CA 94110, USA</p>
          <p className="text-gray-200 mb-1">
            <strong className="text-white">Weboldal:</strong>{' '}
            <a href="https://wordpress.com" target="_blank" rel="noreferrer" className="text-yellow-200 hover:underline">https://wordpress.com</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">Jogi nyilatkozat</h2>
          <p className="text-gray-200 mb-3">
            A weboldal tartalma szerzői jogvédelem alatt áll. Az oldal bármely részének másolása, terjesztése, módosítása csak a szerző írásos engedélyével lehetséges.
          </p>
          <p className="text-gray-200">
            A weboldalon megjelenő spirituális tartalmak nem minősülnek egészségügyi vagy pszichológiai tanácsadásnak.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-[#d6c090] text-xl font-semibold border-b border-white/10 pb-2 mb-4">Adatkezelés</h2>
          <p className="text-gray-200">
            Az oldal nem gyűjt automatikusan személyes adatokat. Kapcsolatfelvétel esetén kizárólag az e-mailben megadott adatokat használjuk a kommunikáció céljára, harmadik fél részére nem adjuk át. A részletes szabályokat az{' '}
            <Link to="/adatkezeles" className="text-yellow-200 hover:underline">Adatkezelési tájékoztató</Link> tartalmazza.
          </p>
        </section>

        <div className="text-center mt-12 text-sm text-[#b3a693]">
          © {new Date().getFullYear()} Celestine – Minden jog fenntartva.
        </div>
      </div>

      <style jsx>{`
        .brand {
          font-family: "Great Vibes", cursive;
        }
        .glow {
          text-shadow: 0 0 12px rgba(255, 255, 255, 0.35), 0 0 24px rgba(199, 146, 12, 0.25);
        }
      `}</style>
    </div>
  );
};

export default Impresszum;
